/**
 * Initializes the generic OverflowMenu
 *
 */
export function initZdsOverflowMenu() {
    $(document).on('click', '[data-open-zds-menu]', (event) => {
        const target = $(event.target);
        const menuId = target.closest('[data-open-zds-menu]').attr('data-zds-menu-id');
        $(`#${menuId}`).toggle();
    });
    // close the menu when one of the options are clicked
    $(document).on('click', '.meatball_menu_item', (event) => {
        const target = $(event.target);
        target.closest('.zds_meatball_menu').hide();
    });
}
